import { CustomButtonProps } from "./custom-button-type";
import { ButtonStyled } from "./style-component";


const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  variant = 'solid',
  onClick,
  color,
  type,
  ...props
}) => {
  return (
    <ButtonStyled
      type={type}
      variant={variant}
      onClick={onClick}
      color={color}
      {...props}
    >
      {children}
    </ButtonStyled>
  )
};

export default CustomButton